import emailSettingsReducer from './email/email.reducer';
import chatSettingsReducer from './chat/chat.reducer';
import socialSettingsReducer from './social/social.reducer';
import { EmailSettingsAction } from './email/email.actions';
import { ChatSettingsAction } from './chat/chat.actions';
import { SocialSettingsAction } from './social/social.actions';
import { ChannelSettingsAction } from './action';
import { WebFormSettingsAction } from './webform/webform.actions';
import webFormSettingsReducer from './webform/webform.reducer';
import messagingSettingsReducer from './messaging/messaging.reducer';
import { MessagingSettingsAction } from './messaging/messaging.actions';

const defaultState = {
    email: {},
    chat: {},
    social: {},
    messaging: {},
    webform: {},
};

const channelSettingsReducer = (
    state = defaultState,
    action: ChannelSettingsAction
) => action.type === 'RESET_CHANNEL_SETTNGS_STORE'
    ? defaultState
    : {
        email: emailSettingsReducer(state.email, action as EmailSettingsAction),
        chat: chatSettingsReducer(state.chat, action as ChatSettingsAction),
        social: socialSettingsReducer(state.social, action as SocialSettingsAction),
        messaging: messagingSettingsReducer(state.messaging, action as MessagingSettingsAction),
        webform: webFormSettingsReducer(
            state.webform,
            action as WebFormSettingsAction
        ),
    };

export default channelSettingsReducer;
